import { action } from "satcheljs";

export interface OnItemPartSelectedActionMessage {
    conversationNodeId: string;
    conversationId: string;
}
const defaultExport: (conversationNodeId: string, conversationId: string) => OnItemPartSelectedActionMessage = action("ON_ITEM_PART_SELECTED", (conversationNodeId: string, conversationId: string): OnItemPartSelectedActionMessage => ({
    conversationNodeId,
    conversationId,
}));
export default defaultExport;
